// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
var measure = function (dictMonadEffect) {
    if (Specular_Internal_Profiling.enabled) {
        return function (name) {
            return function (action) {
                return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(function () {
                    return Specular_Internal_Profiling.begin(name);
                }))(function (mark) {
                    return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(action)(function (result) {
                        return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(function () {
                            return Specular_Internal_Profiling.end(mark);
                        }))(function () {
                            return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(result);
                        });
                    });
                });
            };
        };
    };
    return function (v) {
        return function (action) {
            return action;
        };
    };
};
var end = /* #__PURE__ */ (function () {
    if (Specular_Internal_Profiling.enabled) {
        return Effect_Uncurried.runEffectFn1(Specular_Internal_Profiling.end);
    };
    return function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    };
})();
var begin = /* #__PURE__ */ (function () {
    if (Specular_Internal_Profiling.enabled) {
        return Effect_Uncurried.runEffectFn1(Specular_Internal_Profiling.begin);
    };
    return function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Specular_Internal_Profiling.none);
    };
})();
export {
    begin,
    end,
    measure
};
export {
    enabled
} from "../Specular.Internal.Profiling/index.js";
//# sourceMappingURL=index.js.map
